import { Box } from '@chakra-ui/react';
import React from 'react';
import { InsuranceInfoFooterProps } from './InsuranceInfo';


export const InsuranceInfoFooter = ({ children, sx, ...rest }: InsuranceInfoFooterProps) => {
    return (
        <Box
            sx={{
                display: { base: 'grid', md: 'flex' },
                rowGap: { base: 4, lg: 0 },
                alignItems: 'center',
                justifyContent: 'space-between',
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Box>
    );
};
